module.exports = "https://cdn.hellotech.com/client-assets/video_doorbell_tablet_5274a2cd813b169cd492a2a3c2497c03.png";